import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import BetHistory from '@/views/bet-history/BetHistory'
import Users from '@/views/users-management/Users'
import TestUsers from '@/views/users-management/TestUsers'
import Admins from '@/views/Admins'
import AdminList from '@/views/admin-management/AdminList'
import PermissionList from '@/views/admin-management/PermissionList'
import Whitelist from '@/views/admin-management/Whitelist'
import AdminLogs from '@/views/admin-management/AdminLogs'
import SuperAdminLogs from '@/views/super-admin-management/SuperAdminLogs'
import UserDetails from '@/views/users-management/UserDetails'
import TransfersList from '@/views/transfer-management/TransfersList'
import TransferDetails from '@/views/transfer-management/TransferDetails'
import PointsList from '@/views/points-management/PointsList'
import Games from '@/views/game-management/Games'
import Leagues from '@/views/game-management/Leagues'
import Matches from '@/views/game-management/Matches'
import Banks from '@/views/bank-management/Banks'
import Domains from '@/views/domain-management/Domains'
import Match from '@/views/game-management/Match'
import Countries from '@/views/game-management/Countries'
import DepositAccounts from '@/views/deposit-account-management/DepositAccounts'
import Codes from '@/views/codes-management/Codes'
import Agents from '@/views/agents-management/Agents'
import AgentDetails from '@/components/common/agent-details/AgentDetails'
import IP from '@/views/ip-management/ip'
import SupportMessages from '@/views/support-management/Messages'
import SupportMessagesDetails from '@/components/common/message/SupportMessages'
import SupportRequests from '@/views/support-management/Requests'
import Faqs from '@/views/support-management/Faqs'
import FreeBoards from '@/views/boards/FreeBoards'
import FreeboardDetails from '@/views/boards/FreeboardDetails'
import Notices from '@/views/boards/Notices'
import Events from '@/views/boards/Events'
import PageNotFound from '@/views/errors/PageNotFound'
import Login from '@/views/login/Login'
import Logout from '@/views/login/Logout'
import Scraper from '@/views/game-management/Scraper'
import Marquee from '@/views/settings/Marquee'
import Menu from '@/views/settings/Menu'
import Point from '@/views/settings/Point'
import Banner from '@/views/settings/Banner'
import Level from '@/views/settings/Level'
import Sound from '@/views/settings/Sound'
import UserRegistration from '@/views/settings/UserRegistration'
import ImportAgent from '@/views/import-management/ImportAgent'
import ImportUser from '@/views/import-management/ImportUser'
import ImportMemo from '@/views/import-management/ImportMemo'

import { checkPermission } from '@/assets/js/common/CheckPermission.js'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home-page',
    meta: { dbKey: 'admins' },
    component: AdminList
  },

  {
    path: '/login',
    name: 'login-page',
    meta: { dbKey: '' },
    component: Login
  },

  {
    path: '/logout',
    name: 'logout-page',
    component: Logout
  },

  {
    path: '/admin-list/:status?',
    name: 'admin-list-page',
    meta: { dbKey: 'admins' },
    component: AdminList
  },

  {
    path: '/permission-list/:status?',
    name: 'permission-list-page',
    meta: { dbKey: 'admins' },
    component: PermissionList
  },

  {
    path: '/whitelist/:status?',
    name: 'whitelist-page',
    meta: { dbKey: 'admins' },
    component: Whitelist
  },

  {
    path: '/admin-logs/:type?/:status?',
    name: 'admin-logs-page',
    meta: { dbKey: 'admin-logs' },
    component: AdminLogs
  },

  {
    path: '/super-admin-logs/:status?',
    name: 'super-admin-logs-page',
    meta: { dbKey: 'super-admin-logs' },
    component: SuperAdminLogs
  },

  {
    path: '/import/agent',
    name: 'import-agent-page',
    meta: { dbKey: 'import' },
    component: ImportAgent
  },

  {
    path: '/import/user',
    name: 'import-user-page',
    meta: { dbKey: 'import' },
    component: ImportUser
  },

  {
    path: '/import/memo',
    name: 'import-memo-page',
    meta: { dbKey: 'import' },
    component: ImportMemo
  },

  {
    path: '*',
    name: '404-page',
    meta: { dbKey: '' },
    component: PageNotFound
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   if (to.path !== '/logout' && to.path !== '/login') {
//     let permission = JSON.parse(window.localStorage.permission)
//     let metaKey = to.meta.dbKey.toLowerCase()
//     let allowedRoutes = Object.keys(permission)

//     console.log(allowedRoutes)

//     if (allowedRoutes.find((e) => {
//       return e === metaKey ? 1 : ''
//     })) {
//       console.log('')
//       next({ path: to.path })
//     } else {
//       console.log('nope')
//     }
//   }
//   next()
// })

router.beforeEach((to, from, next) => {
  const paths = ['/login', '/logout', '/admins']

  if (!window.localStorage.token && to.path !== '/login') {
    return next({ name: 'login-page' })
  }

  if (window.localStorage.token && to.name === 'login-page') {
    return next('/admin-list/all')
  }

  if (to.path === '/admins' && Number(window.localStorage.permission) !== 4) {
    return next({ path: '/users' })
  }

  if (Number(window.localStorage.permission) === 4 && paths.indexOf(to.path) === -1) {
    return next({ path: '/admins' })
  }

  return next()
})

router.beforeResolve((to, from, next) => {
  document.body.classList.add(to.name)
  document.body.classList.remove(from.name)

  if (document.body.classList.contains(to.name)) {
    document.body.classList.add(to.name)
  }

  next()
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
